import * as React from 'react'

import { Alert, Box, Button, Link, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

import { ActivatePayload } from 'modules/app_store/lib/SubscriptionAddonInstaller'
import { useIntegration } from 'modules/ats/hooks/integrations/useIntegration'

interface Props {
  onSuccess: (payload?: ActivatePayload | null | undefined) => Promise<boolean>
  onClose: () => void
}

const ActivateIdealDiscModal = ({ onSuccess, onClose }: Props) => {
  const { integration } = useIntegration()
  const [inputApiKey, setInputApiKey] = React.useState<string>('')
  const url = 'https://app.idealdisc.com.br/user/profile'
  const newAccountIdealdiscUrl = 'https://landing.idealdisc.com.br/primeiro-acesso-factorial'

  const setApiKey = async () => {
    return inputApiKey
  }

  const onSubmit = () => {
    setApiKey().then((apiKey) => {
      onSuccess({
        idealdisc_api_key: apiKey,
      })
    })
  }

  const disabledButton = integration === undefined && inputApiKey.length < 1

  return (
    <Modal
      title={i18n.t('app_store_v2.app_integrations.dev_ats_ideal_disc_integration.modal.title')}
      illustration="sync"
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={disabledButton} type="primary" submit>
            {i18n.t('common.submit')}
          </Button>
        </>
      }
    >
      <Box gap="s32">
        <Box gap="s24">
          <Box gap="s8">
            <Link.Href href={newAccountIdealdiscUrl}>
              {i18n.t(
                'app_store_v2.app_integrations.dev_ats_ideal_disc_integration.modal.open_account'
              )}
            </Link.Href>
            <Link.Href href={url}>
              {i18n.t(
                'app_store_v2.app_integrations.dev_ats_ideal_disc_integration.modal.create_api_key'
              )}
            </Link.Href>
          </Box>
          <Box>
            <TextField
              label={i18n.t(
                'app_store_v2.app_integrations.dev_ats_ideal_disc_integration.modal.api_key_input'
              )}
              onChange={setInputApiKey}
              mandatory={integration == undefined}
            />
          </Box>
        </Box>
        <Box>
          <Alert color="note">
            <Text weight="bold" size={'200'}>
              {i18n.t(
                'app_store_v2.app_integrations.dev_ats_ideal_disc_integration.modal.alert.title'
              )}
            </Text>
            {i18n.t(
              'app_store_v2.app_integrations.dev_ats_ideal_disc_integration.modal.alert.description'
            )}
          </Alert>
        </Box>
      </Box>
    </Modal>
  )
}

export default observer(ActivateIdealDiscModal)
